import type { FunctionComponent } from "react";
import { graphql, useFragment, useLazyLoadQuery } from "react-relay";

import { useCurrentPageType } from "shared/hooks";
import { useEditionValue } from "shared/lib/edition";

import type { headerOnelineMenuStyleItemsQuery } from "scmp-app/queries/__generated__/headerOnelineMenuStyleItemsQuery.graphql";
import type { headerOnelineMenuStyleQuery$key } from "scmp-app/queries/__generated__/headerOnelineMenuStyleQuery.graphql";

import { Container, StyledEntityLink, StyledSectionStyleHeaderMenuItem } from "./styles";

export type Props = {
  className?: string;
};

export const HeaderOnelineMenuStyle: FunctionComponent<Props> = ({ className }) => {
  const queryReference = useLazyLoadQuery<headerOnelineMenuStyleItemsQuery>(
    graphql`
      query headerOnelineMenuStyleItemsQuery {
        ...headerOnelineMenuStyleQuery
      }
    `,
    {},
  );

  const data = useFragment<headerOnelineMenuStyleQuery$key>(
    graphql`
      fragment headerOnelineMenuStyleQuery on Query {
        styleOnelineMenu: queue(filter: { name: "scmp_pwa_oneline_menu_style" }) {
          items(first: 100) {
            edges {
              node {
                ... on Section {
                  ...entityLink
                  ...sectionStyleHeaderMenuItem
                }
              }
            }
          }
        }
      }
    `,
    queryReference,
  );

  const edition = useEditionValue();
  const currentPageType = useCurrentPageType();
  return (
    <Container aria-label="Style section" className={className}>
      {data.styleOnelineMenu?.items?.edges.map((edge, index) => (
        <StyledEntityLink
          key={index}
          query={{
            module: `oneline_menu_section_${edition}`,
            pgtype: currentPageType,
          }}
          reference={edge.node}
        >
          <StyledSectionStyleHeaderMenuItem reference={edge.node} />
        </StyledEntityLink>
      ))}
    </Container>
  );
};

HeaderOnelineMenuStyle.displayName = "HeaderOnelineMenuStyle";
